module.exports = __webpack_public_path__ + "img/Artboard 1_3.jpg";